import React from 'react';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DateTimePickerInput from 'screens/components/basic/DateTimePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import DropdownInput from 'screens/components/basic/DropdownInput';
import TextInput from 'screens/components/basic/TextInput';
import ClearIcon from '@mui/icons-material/Clear';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "ProductSales";
const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-2 m-0">
                <DateTimePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-2 m-0">
                <DateTimePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label}
                    hintText={LOOKUP.report.common.endDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 m-0">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={props.loggedBranch.toString()}
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-2">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue="2"
                    label={"Category"}
                    floatingLabelText={"Category"}
                    hintText={"Category"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div>  {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-2 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.subcategory}
                    floatingLabelText={LOOKUP.report.common.subcategory}
                    hintText={LOOKUP.report.common.subcategory}
                    options={props.productCategories && props.productCategories.length > 0 ? (props.isCannabis == 0 ? props.productCategories.filter(x => !x.isCannabis) : (props.isCannabis == 1 ? props.productCategories.filter(x => x.isCannabis) : props.productCategories)) : []}
                />
            </div> {/* .col */}
        </div>
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-6 col-md-2">
                <SelectInput
                    name={componentName + "Type"}
                    fullWidth={true}
                    defaultValue="0"
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.typeOptions && props.typeOptions.length > 0 ? props.typeOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3">
                <SelectInput
                    name={componentName + "Weight"}
                    fullWidth={true}
                    floatingLabelText={"Weight (G)"}
                    hintText={"Weight (G)"}
                    options={props.weightOptions && props.weightOptions.length > 0 ? props.weightOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3">
                <TextInput
                    name={componentName + "BrandName"}
                    floatingLabelText={"Brand Name Filter"}
                    hintText={"Brand Name Filter"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-7 col-md-7">
                <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    className={"AutoCompleteInput-searchbar"}
                    label={"Search an existing product"}
                    hintText="Product"
                    fullWidth={false}
                    options={props.products}
                    listStyle={{ maxHeight: 200, overflow: 'auto' }}
                />
            </div> {/* .col */}
        </div>
        <div className="row mt-2 mb-1">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                <Button
                    type="IconInButton"
                    className="pull-right ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
                <Button
                    type="IconInButton"
                    className="pull-right  btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.ClearFilter.name}
                    label={LOOKUP.report.common.ClearFilter.label}
                    icon={<ClearIcon />}
                    onTouchTap={props.clearFilter}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Only completed and refunded products will be counted in this report. Total sale price doesn't include tax, no deposit amount is counted in gross sales in this report.</i></strong></p>
                <p className='purpleText'><strong className="blue-text"><i>If a product is refunded, there will be a record for its sales and another record for the refund.</i></strong></p>
                <p className='purpleText'><strong className="blue-text"><i>Tax and deposit values in summaries have refunds deducted. Discounts and gross sales are for sales only.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
